/* Coastal Standard — Variant Image Filter v5
 * Filters product gallery images by selected color variant.
 * v5: Full Flickity destroy/reinit on every filter to prevent carousel death.
 *     Lazy-load force for images moved into view.
 *     URL variant param support.
 */
(function() {
  'use strict';

  function filterGalleryImages(selectedColor) {
    var gallery = document.querySelector('media-gallery');
    if (!gallery) return;

    var mainContainer = gallery.querySelector('flickity-component.f-product__media-list');
    if (!mainContainer) {
      mainContainer = gallery.querySelector('[data-media-viewer] flickity-component');
    }
    if (!mainContainer) return;

    // === Destroy Flickity FIRST so DOM manipulation is clean ===
    destroyFlickity(mainContainer);

    // Create or find the hidden holder (outside mainContainer)
    var mainHolder = document.getElementById('cs-main-holder');
    if (!mainHolder) {
      mainHolder = document.createElement('div');
      mainHolder.id = 'cs-main-holder';
      mainHolder.style.display = 'none';
      gallery.appendChild(mainHolder);
    }

    // Move everything back from holder
    var held = mainHolder.querySelectorAll('.f-product__media');
    held.forEach(function(el) { mainContainer.appendChild(el); });

    // Move non-matching images to holder
    var allMedia = mainContainer.querySelectorAll('.f-product__media');
    var matchCount = 0;
    allMedia.forEach(function(slide) {
      var img = slide.querySelector('img');
      var alt = img ? (img.alt || '').trim() : '';
      if (alt && alt.toLowerCase() === selectedColor.toLowerCase()) {
        matchCount++;
      }
    });
    // Only filter if at least one image matches the color name in alt text.
    // If no images match, alt text isn't set to color names — show all images.
    if (matchCount > 0) {
      allMedia.forEach(function(slide) {
        var img = slide.querySelector('img');
        var alt = img ? (img.alt || '').trim() : '';
        if (alt && alt.toLowerCase() !== selectedColor.toLowerCase()) {
          mainHolder.appendChild(slide);
        }
      });
    }

    // Force lazy images to load
    forceLoadImages(mainContainer);

    // Reinitialize Flickity
    reinitFlickity(mainContainer);

    // === Thumbnail strip ===
    var thumbContainer = gallery.querySelector('flickity-component.f-product__media-thumbnails');
    if (thumbContainer) {
      destroyFlickity(thumbContainer);

      var thumbHolder = document.getElementById('cs-thumb-holder');
      if (!thumbHolder) {
        thumbHolder = document.createElement('div');
        thumbHolder.id = 'cs-thumb-holder';
        thumbHolder.style.display = 'none';
        gallery.appendChild(thumbHolder);
      }

      var heldThumbs = thumbHolder.querySelectorAll('.f-product__media-thumbnails-item');
      heldThumbs.forEach(function(el) { thumbContainer.appendChild(el); });

      var allThumbs = thumbContainer.querySelectorAll('.f-product__media-thumbnails-item');
      var thumbMatchCount = 0;
      allThumbs.forEach(function(thumb) {
        var img = thumb.querySelector('img');
        var alt = img ? (img.alt || '').trim() : '';
        if (alt && alt.toLowerCase() === selectedColor.toLowerCase()) thumbMatchCount++;
      });
      if (thumbMatchCount > 0) {
        allThumbs.forEach(function(thumb) {
          var img = thumb.querySelector('img');
          var alt = img ? (img.alt || '').trim() : '';
          if (alt && alt.toLowerCase() !== selectedColor.toLowerCase()) {
            thumbHolder.appendChild(thumb);
          }
        });
      }

      forceLoadImages(thumbContainer);
      reinitFlickity(thumbContainer);
    }

    gallery.removeAttribute('data-media-loading');
  }

  function destroyFlickity(container) {
    var flkty = null;
    // Try theme pattern
    if (container.slider && container.slider.instance) {
      flkty = container.slider.instance;
    }
    // Try Flickity.data pattern
    if (!flkty && typeof Flickity !== 'undefined') {
      var viewport = container.querySelector('.flickity-viewport');
      if (viewport) {
        flkty = Flickity.data(viewport) || Flickity.data(container);
      }
    }
    if (flkty) {
      try { flkty.destroy(); } catch(e) {}
    }
    // Clean up Flickity DOM artifacts
    var viewport = container.querySelector('.flickity-viewport');
    if (viewport) {
      // Move children out of viewport back to container
      var slider = viewport.querySelector('.flickity-slider');
      var source = slider || viewport;
      while (source.firstChild) {
        container.appendChild(source.firstChild);
      }
      viewport.remove();
    }
    // Remove flickity classes
    container.classList.remove('flickity-enabled');
    // Remove page counter
    var counter = container.querySelector('.flickity-page-counter');
    if (counter) counter.remove();
    // Remove nav buttons
    container.querySelectorAll('.flickity-button').forEach(function(b) { b.remove(); });
  }

  function reinitFlickity(container) {
    // Let the theme's custom element re-initialize
    if (container.slider && typeof container.slider.init === 'function') {
      try {
        container.slider.init();
        return;
      } catch(e) {}
    }
    // Fallback: initialize via Flickity directly
    if (typeof Flickity !== 'undefined') {
      try {
        var opts = {
          cellSelector: container.classList.contains('f-product__media-thumbnails')
            ? '.f-product__media-thumbnails-item'
            : '.f-product__media',
          wrapAround: false,
          pageDots: false,
          prevNextButtons: true,
          contain: true,
          adaptiveHeight: true
        };
        new Flickity(container, opts);
      } catch(e) {}
    }
  }

  function forceLoadImages(container) {
    container.querySelectorAll('img').forEach(function(img) {
      if (!img.complete || img.naturalWidth === 0) {
        img.loading = 'eager';
        var src = img.getAttribute('src');
        if (src) { img.removeAttribute('src'); img.setAttribute('src', src); }
        var srcset = img.getAttribute('srcset');
        if (srcset) { img.removeAttribute('srcset'); img.setAttribute('srcset', srcset); }
      }
    });
  }

  function getSelectedColor() {
    // Check URL variant parameter first
    var urlParams = new URLSearchParams(window.location.search);
    var variantId = urlParams.get('variant');
    if (variantId) {
      var productJsonEl = document.querySelector('[data-product-json]');
      if (productJsonEl) {
        try {
          var productData = JSON.parse(productJsonEl.textContent);
          var variants = productData.variants || [];
          for (var i = 0; i < variants.length; i++) {
            if (String(variants[i].id) === String(variantId)) {
              var options = productData.options || [];
              for (var j = 0; j < options.length; j++) {
                if (/color|colour/i.test(options[j].name)) {
                  var colorValue = variants[i]['option' + (j + 1)];
                  if (colorValue) return colorValue;
                }
              }
            }
          }
        } catch(e) {}
      }
    }

    // Fallback: check radio buttons
    var radios = document.querySelectorAll('input[type=radio]:checked');
    for (var i = 0; i < radios.length; i++) {
      if (/color|colour/i.test(radios[i].name)) return radios[i].value;
    }
    // Check select dropdowns
    var selects = document.querySelectorAll('select');
    for (var i = 0; i < selects.length; i++) {
      if (/color|colour/i.test(selects[i].name || selects[i].dataset.optionName || '')) {
        return selects[i].value;
      }
    }
    return null;
  }

  document.addEventListener('DOMContentLoaded', function() {
    // Desktop: activate left-side vertical thumbnail layout (cs-side-thumbs CSS in product.css)
    if (window.innerWidth >= 768) {
      var mg = document.querySelector('media-gallery');
      if (mg) mg.classList.add('cs-side-thumbs');
    }

    setTimeout(function() {
      var color = getSelectedColor();
      if (color) filterGalleryImages(color);
    }, 1200);
  });

  document.addEventListener('change', function(e) {
    var target = e.target;
    if (target.matches('input[type="radio"], select')) {
      var name = target.name || target.dataset.optionName || '';
      if (/color|colour/i.test(name)) {
        var color = target.value;
        if (color) {
          setTimeout(function() { filterGalleryImages(color); }, 100);
        }
      }
    }
  });
})();
